export enum FundingInputLabel {
  BankAccountNumber = 'Bank Account Number',
  ConfirmBankAccountNumber = 'Confirm Bank Account Number',
  RoutingNumber = 'Routing Number',
  ConfirmRoutingNumber = 'Confirm Routing Number',
}
